<template>
  <div v-if="owner != null">
    <individual-bank-details class="mt-2" :owner="owner" />
  </div>
</template>
<script>
import IndividualBankDetails from "./all.vue";
export default {
  components: { IndividualBankDetails },
  data() {
    return {
      owner: null,
    };
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      await this.$http.get("api/v1/auth/current").then((response) => {
        this.owner = response;
      });
    },
  },
};
</script>
